import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { setSearchText } from "../../../store/userProfileOrganization";

export const OrganizationSearchBar = () => {
    const dispatch = useDispatch();
    const searchText = useSelector((state: RootState) => state.userProfileOrganization.searchText);

    return (
        <IonSearchbar
            value={searchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSearchText(value));
            }}
            debounce={700}
            placeholder={"Buscar Clientes..."}
            autocomplete="off"
        />
    );
};